<template>
	<IconButtonLayout class="add-button">
		<template #default="{ iconClass }">
			<FontAwesomeIcon
				:title="title"
				:class="iconClass"
				:icon="[ `fas`, `plus`]"
			/>
		</template>
	</IconButtonLayout>
</template>

<script>
import IconButtonLayout from "./IconButtonLayout.vue";

export default {
	name: "AddButton",
	components: {
		IconButtonLayout,
	},
	props: {
		title: {
			type: String,
			default: "",
		},
	},
};
</script>

<style lang="scss" scoped></style>
